// extracted by mini-css-extract-plugin
export default {"backArrow":"BackArrow_backArrow__nf5X1","arrowImage":"BackArrow_arrowImage__DSmm-"};